import React, { ReactElement } from "react";
import IllustrationCardUi from "../../IllustrationCard/IllustrationCard";
import { IllustrationCardType } from "../../types/IllustrationCard";
import { useHasMounted } from "../hooks/useHasMounted";
import { navigate } from "gatsby";
import { Builder } from "@builder.io/react";

const IllustrationCard: React.FC<IllustrationCardType> = ({
  link,
  ...rest
}): ReactElement | null => {
  const isMounted = useHasMounted();

  if (!isMounted) return null;

  const currentLink = link?.ctaLink?.value?.data?.url || link?.ctaUrl;

  const triggerAnalytics = () => {
    window?.analytics.track("Link Clicked", {
      url: window.location.pathname,
      text: link?.ctaCopy,
      target: currentLink,
      action: "Clicked",
      initiator: "User",
      object: "Link",
      source_application: "Marketing",
    });
  };

  const onClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    if (currentLink) {
      e.preventDefault();
      triggerAnalytics();
      navigate(currentLink);
    }
  };

  return (
    <IllustrationCardUi
      {...rest}
      link={link}
      onClick={onClick}
      triggerAnalytics={triggerAnalytics}
    />
  );
};

export default IllustrationCard;

export const RegisterIllustrationCard = () => {
  Builder.registerComponent(IllustrationCard, {
    name: "illustration-card-molecule",
    inputs: [
      {
        name: "dropdown",
        friendlyName: "Dropdown",
        type: "",
        defaultValue: "short",
        enum: [
          { label: "Short", value: "short" },
          { label: "Long", value: "long" },
        ],
      },
      {
        name: "headline",
        type: "string",
      },
      {
        name: "subCopy",
        type: "longText",
      },
      {
        name: "link",
        type: "object",
        subFields: [
          {
            name: "ctaCopy",
            type: "string",
          },
          {
            name: "ctaLink",
            type: "reference",
            model: "page",
          },
          {
            name: "ctaUrl",
            type: "string",
          },
        ],
      },
      {
        name: "illustration",
        type: "file",
      },
      {
        name: "illustrationAltText",
        type: "longText",
      },
    ],
  });
};
